export class AppConfig {
  static xsrc = 'module-library';
}
